import React from "react";
import { FaAddressBook, FaHome, FaUniversity } from "react-icons/fa";

import {
  getCompletionPercent,
  TABS,
} from "../utils/parametresUtils";

const icons = {
  identity: FaUniversity,
  contact: FaAddressBook,
  home: FaHome,
};

const statKeys = {
  identity: ["identityFilled", "identityTotal"],
  contact: ["contactFilled", "contactTotal"],
  home: ["homeFilled", "homeTotal"],
};

export default function SettingsTabs({ activeTab, setActiveTab, stats }) {
  return (
    <section className="grid gap-3 lg:grid-cols-3">
      {TABS.map((tab) => {
        const Icon = icons[tab.key];
        const isActive = activeTab === tab.key;
        const [filledKey, totalKey] = statKeys[tab.key];

        const percent = getCompletionPercent(
          stats?.[filledKey],
          stats?.[totalKey]
        );

        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            className={`group rounded-3xl border p-5 text-left transition hover:-translate-y-1 ${
              isActive
                ? "border-slate-950 bg-slate-950 text-white shadow-xl shadow-slate-300/50 dark:border-white dark:bg-white dark:text-slate-950 dark:shadow-none"
                : "border-slate-200 bg-white text-slate-900 shadow-sm shadow-slate-200/60 hover:shadow-lg hover:shadow-slate-200/80 dark:border-slate-800 dark:bg-slate-900 dark:text-white dark:shadow-none"
            }`}
          >
            <div className="flex items-start justify-between gap-4">
              <span
                className={`grid h-12 w-12 place-items-center rounded-2xl ${
                  isActive
                    ? "bg-white/10 text-orange-200 dark:bg-slate-950/10 dark:text-orange-600"
                    : "bg-orange-50 text-orange-600 dark:bg-orange-500/10 dark:text-orange-300"
                }`}
              >
                <Icon />
              </span>

              <span
                className={`rounded-full px-3 py-1 text-xs font-bold ${
                  isActive
                    ? "bg-white/10 text-white dark:bg-slate-950/10 dark:text-slate-950"
                    : "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300"
                }`}
              >
                {percent}%
              </span>
            </div>

            <h3 className="mt-4 text-lg font-bold">{tab.label}</h3>
            <p
              className={`mt-1 text-sm ${
                isActive
                  ? "text-slate-200 dark:text-slate-600"
                  : "text-slate-500 dark:text-slate-400"
              }`}
            >
              {tab.helper}
            </p>
          </button>
        );
      })}
    </section>
  );
}